/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';
import commands from './commands';
import MetricsContext from './MetricsContext';
import { useContext, useState, useEffect } from 'react';
import cx from 'classnames';
import InputEditor from './InputEditor';

type PropsT = { name: string, minWidth: string };

export default ({ name, minWidth, ...rest }: PropsT): Element<string> => {
  const ctx = useContext(MetricsContext);
  const [hasText, setHasText] = useState(false);
  const [value, setValue] = useState();

  const onChange = (v) => {
    if (v) {
      !hasText && setHasText(true);
    } else {
      hasText && setHasText(false);
    }
    commands(ctx).set('widgetForm.' + name, v);
  };

  useEffect(() => {
    const w = ctx.state.widgetForm;
    let v = w[name];
    if (name === 'formula') {
      if (v) {
        v = `${w.prefix || ''}${v}${w.postfix || ''}`;
      } else {
        v = '{value * 1}';
        commands(ctx).set('widgetForm.formula', v);
      }
    }
    setValue(v);
  }, []);

  return (
    <span
      className={cx('Editable', { Edited: hasText })}
      css={css(`
        .DraftEditor-root {
          display: inline-block;
          min-width: ${minWidth || '25px'};
        }
        .public-DraftStyleDefault-block {
          margin: 0;
      }`)}
    >
      <InputEditor {...rest} value={value} onChange={onChange} />
    </span>
  );
};
